import get from 'lodash/get'

export const applyFeatureOffset = (feature, offsetMap) => {
  const id = get(feature, 'properties.id')
  const offset = offsetMap[id]
  if (!offset) return feature
  return {
    ...feature,
    geometry: { ...feature.geometry, coordinates: [offset.lng, offset.lat] },
  }
}
